<template>
  <div>
    <h4>Onboarding team</h4>
    <p></p>
    <b-row>
      <b-col lg="4">
        <b-card>
          <b-card-img style="margin-top: 2rem;" height="180" width="180" src="img/bg/Onboarding_Team.svg"
            alt="Center image">
          </b-card-img>
          <b-card-title class="mt-4">이름과 이메일 주소</b-card-title>
          <b-card-text>
            조직의 각 온보딩 팀원은 KFT Food Trust에 등록되어 이 역할에 할당되어야 합니다. 그들의 이름과 이메일 주소를 입력하는 것으로 시작하세요.
          </b-card-text>
        </b-card>
      </b-col>
      <b-col>
        <b-card-group deck>
          <b-card>
            <h4 class="text-center">권장 기술 및 전문 지식</h4>
            <b-row>
              <b-col lg="6">
                <b-card-img height="180" width="180" src="img/bg/Supply_Chain_Specialist.svg"></b-card-img>
                <b-card-title class="mt-4">공급망 전문가</b-card-title>
                <b-card-text>
                  온보딩 팀원 역할에 공급망 전문가를 추가하세요. 그들은 조직의 중요한 공급망 데이터 포인트가 매핑되어 KFT Food Trust에 업로드되도록 할 것입니다.
                </b-card-text>
              </b-col>
              <b-col lg="6">
                <b-card-img height="180" width="180" src="img/bg/Onboarding_Specialist.svg">
                </b-card-img>
                <b-card-title class="mt-4">시스템 개발자</b-card-title>
                <b-card-text>
                  시스템 통합 개발자를 온보딩 팀원 역할에 추가하세요. 그들은 공급망 데이터를 KFT Food Trust에 자동으로 업로드하도록 네이티브 시스템을 구성할 것입니다.
                </b-card-text>
              </b-col>
            </b-row>

          </b-card>
        </b-card-group>
      </b-col>
    </b-row>


    <div v-if="!showDetail">
      <p></p>
      <h4>온보딩 팀원</h4>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col lg="8">
              </b-col>
              <b-col class="text-right">
                <b-button variant="dark" squared style="width:150px;argin-bottom: 0.5rem;" @click="register">팀원등록
                </b-button>
              </b-col>
            </b-row>
            <p></p>
            <b-skeleton-wrapper :loading="loading">
              <template #loading>
                <b-skeleton-table :rows="5" :columns="fields.length" :table-props="{ bordered: true, striped: true }">
                </b-skeleton-table>
              </template>
              <!-- style="margin-bottom: 0.5rem;" -->
              <!-- :per-page="perPage"
                :current-page="currentPage" -->
              <b-table v-if="onComplate" striped bordered id="my-table" :items="items" :fields="fields"
                @row-clicked="myRowClickHandler" hover responsive>
                <template v-slot:cell(no)="data">
                  {{ (currentPage-1)*perPage + (data.index+1) }}
                </template>
                <template #cell(address)="data">
                  <span v-html="data.value"></span>
                </template>
              </b-table>
              <!-- <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="my-table">
              </b-pagination> -->
            </b-skeleton-wrapper>

          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <p></p>
      <h4>시설을 등록합니다.</h4>
      <TeamDetailsVue :company="company" :record="facility" :updateMode="updateMode" @OnClosed="onClosed"
        @OnRefresh="onRefresh">
      </TeamDetailsVue>
    </div>
    <p></p>
  </div>

</template>
<script>

import TeamDetailsVue from './TeamDetails.vue';

export default {
  components: {
    TeamDetailsVue
  },
  created() {
    this.$_loadingTimeInterval = null
  },
  mounted() {
    this.startLoading();
    // this.search()
  },
  async beforeMount() {
    this.company = await this.$getOrganization();
  },
  data() {
    return {
      onComplate: false,
      loading: false,
      perPage: 5,
      currentPage: 1,
      showDetail: false,
      updateMode: false,
      facility: {
        facilityId: null,
        facilityName: null,
        facilityType: null,
        facilityIdType: 'KFT',//GS1 OR KFT
        streetAddress: null,
        city: null,
        state: null,
        postalCode: null,
        country: null,
        gpsX: null,//for wgs84
        gpsY: null,//for wgs84
      },
      company: null,
      items: [],
      fields: [
        { key: 'no', label: 'No.', class: 'text-center' },
        { key: 'facilityName', label: 'Email address', class: 'text-center' },
        { key: 'facilityId', label: 'Name', class: 'text-center' },
        { key: 'facilityType', label: 'User role', class: 'text-center' }
      ],
      settings: {
        closed: this.showDetail,
      }
    }
  },
  methods: {
    onRefresh() {
      // console.log('OnRefresh')
      this.startLoading();
      // this.search();
    },
    async search(ctx) {
      const org = await this.$getOrganization();
      try {
        const response = await this.$http.get(`${org._links.facilities.href}${this.pagination()}`);
        console.log(response)
        this.items = response.data._embedded.facility;
      } catch (err) {
        alert(err)
        // alert('조회 중 에러가 발생하였습니다.');
      }
      return this.items;
    },

    pagination(ctx) {
      if (ctx) {
        return `?page=${ctx.currentPage - 1}&size=${ctx.perPage}`;
      }
      return ''
    },
    myRowClickHandler(record) {
      this.register();
      this.facility = Object.assign({}, record);
      this.updateMode = true;
    },
    register(event) {
      this.showDetail = true;
      this.updateMode = false
      this.$nextTick(() => {
        //do nothing
      })
    },

    clearLoadingTimeInterval() {
      clearInterval(this.$_loadingTimeInterval)
      this.$_loadingTimeInterval = null
    },

    startLoading() {
      this.loading = true
    },
    onClosed() {
      this.showDetail = false;
    },

    fmtSddress(value, key, facility) {
      const address = [];
      if (facility.streetAddress) address.push(facility.streetAddress + '<br>');
      if (facility.city) address.push(facility.city);
      if (facility.state) address.push(facility.state);
      if (facility.country) address.push(facility.regionName);
      return address.join(' ');
    }
  },
  computed: {
    rows() {
      // console.log(this.items.length)
      return this.items.length
    }
  },
  watch: {
    loading(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.clearLoadingTimeInterval()
        if (newValue) {
          this.$_loadingTimeInterval = setInterval(() => {
            this.loading = false;
            this.onComplate = true;
          }, 1000)
        }
      }
    },
  }
}
</script>
<style scoped>
.card-body>>>table>tbody>tr>td {
  cursor: pointer;
}
</style>
